const nonLoadCapacityChecks = new Set<string>([
  'Member Slenderness Ratio Check',
  'Top-Bottom Plates Width at Splice Joint Requirement',
  'Lateral Bite Check',
  'Rotational Stiffness Check',
]);

/**
 * A check result's capacity field most often represents the ratio of the applied force to the allowed force. If a
 * check's capacity does not vary with the amount of applied force, it no longer indicates whether the load on the truss
 * is close to exceeding the truss's capacity, so we can say that it is not a "load capacity check," and we do not
 * include such a capacity when aggregating capacities unless the check is failing.
 */
export const isPassingNonLoadCapacityCheck = (checkResult: Readonly<{ name: string; capacity: number }>) =>
  nonLoadCapacityChecks.has(checkResult.name) && checkResult.capacity <= 1;
